import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import Section from "components/core/Page/Section";
import ModuleSection from "components/molecules/ModuleSection/ModuleSection";
import Breadcrumbs from "../../search/Breadcrumbs/Breadcrumbs";
import "./ModuleLayout.scss";

function ModuleLayout({ content = { sections: [], pageType: "PSP", type: "" }, pageSchema, handleSearch, breadcrumbUrl }) {
	const { sections, pageType, type } = content;
	const location = useLocation();

	useLayoutEffect(() => {
		if (typeof globalThis.window === "undefined") return;
		try {
			globalThis.scrollTo({ top: 0, left: 0, behavior: "instant" });
		} catch (e) {
			// Fallback for browsers that don't support the options form
			try {
				globalThis.scrollTo(0, 0);
			} catch (fallbackError) {
				// no-op if scrollTo unsupported entirely
			}
		}
	}, [location?.pathname]);

	let label = "";
	if (type) {
		label = type.toLowerCase().includes("storage")
			? `${type}`
			: `${type} Storage Units`;
	}

	const breadcrumbList = [{ label: "Home", href: "/" }];
	if (label) {
		breadcrumbList.push({ label, href: breadcrumbUrl || "" });
	}

	return (
		<div className={classNames("module-layout", pageType)}>
			<div className="page-container Breadcrumbs-section">
				<Breadcrumbs
					breadcrumbList={breadcrumbList}
					className="module-layout-breadcrumbs"
				/>
			</div>
			<Section
				className="module-body"
				flush
			>
				{sections?.map((section) => (
					<ModuleSection
						{...section}
						key={section.title}
						handleSearch={handleSearch}
					/>
				))}
			</Section>

			{pageSchema && (
				<script
					key="schema"
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: pageSchema }}
				/>
			)}
		</div>
	);
}

ModuleLayout.propTypes = {
	content: PropTypes.shape({
		type: PropTypes.string,
		pageType: PropTypes.string,
		sections: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string,
				modules: PropTypes.arrayOf(
					PropTypes.shape({
						type: PropTypes.string.isRequired,
						props: PropTypes.object
					})
				)
			})
		)
	}),
	pageSchema: PropTypes.string,
	breadcrumbUrl: PropTypes.string,
	handleSearch: PropTypes.func
};

export default ModuleLayout;
